import styles from "./index.module.less";
import p3Img from "./imgs/p3_img.png";
import P1Content from "@/components/P1Content";
import data from "../data";
import { Flex } from "antd";
import banner from "./imgs/p1_bg.png";

const P3Card = ({
  title,
  desc,
  list,
  index,
}: {
  title: string;
  desc: string;
  list: string[];
  index: number;
}) => {
  return (
    <Flex className={styles.p3_card} align="center">
      <div className={styles.p3_card_index}>0{index + 1}</div>
      <div className={styles.p3_card_divider}></div>
      <Flex vertical>
        <div className={styles.p3_card_title}>
          {title}
        </div>
        <div className={styles.p3_card_desc}>{desc}</div>
      </Flex>
      {/* <ul className={styles.p3_card_list}>
        {list.map((item, index) => (
          <li key={index} className={styles.p3_card_list_item}>
            {item}
          </li>
        ))}
      </ul> */}
    </Flex>
  );
};
const MobileAgentX = () => {
  return (
    <div className={styles.agentx}>
      <div className={styles.p1}>
        <P1Content
          title={data.p1.title}
          subtitle={data.p1.subtitle}
          link={data.p1.link}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <div className={styles.p2_title}>{data.p2.title}</div>
          {/* <img src={p2Img}/> */}
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.p3_title}>
            <span>{data.p3.title.split(" ")[0]}</span>{" "}
            {data.p3.title.split(" ").slice(1).join(" ")}
          </div>
          <div className={styles.p3_list}>
            {data.p3.list.map((item, index) => (
              <P3Card key={index} {...item} index={index} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default MobileAgentX;
